
/**
 * @param {*} b
 * @returns {boolean|undefined} true or false when the specified argument is either of those values, otherwise undefined
 */
export function castBool(b) {
    return b === true || b === false ? !!b : undefined;
}
